import { useTranslation } from "react-i18next";
import PageHeader from "@/components/feature/PageHeader";
import { useTheme } from "@/context/ThemeContext";
import ContactContent from "./components/ContactContent";

export default function ContactPage() {
  const { t } = useTranslation("home");
  const { effectiveTheme } = useTheme();
  const isLight = effectiveTheme === "light";

  return (
    <div
      className={`min-h-screen flex flex-col ${
        isLight ? "bg-[#f5f5f7]" : "bg-cosmic-950"
      }`}
    >
      <PageHeader title={t("contact.title")} subtitle={t("contact.subtitle")} />
      <ContactContent />
    </div>
  );
}